import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import Header from '../Header/Header.js';
import Footer from '../Footer/Footer.js';
import SideBar from './SideBar.js';
import { BsBox } from 'react-icons/bs';
import Select from "react-select";
import { FiDownload, FiFilter, FiX } from "react-icons/fi";
import * as XLSX from 'xlsx';
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { GET_NDR_COUNT, GET_NDR_LIST } from '../graphql/Query/Order.js';
import Table from "../components/Table/index.jsx";

import { capitalizeFirstLetter } from './AllOrders.js';
import moment from 'moment';
import { IoChevronDownCircleOutline, IoClose } from 'react-icons/io5';
import { FaAngleDown, FaCaretDown } from 'react-icons/fa6';
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { CREATE_NDR } from '../graphql/Mutation/Ordre.js';
import { toast } from 'react-toastify';
import SpinLoader from '../components/SpinLoader.js';
import DateFilter from '../Common/DateRange.js';
import { typeOptions } from '../DomesticSellerOrder/AllOrderSeller.js';
import { getDateRange } from '../Common/GetDateRange.js';
import NDRTableHistory from './NDRTableHistory.js';
import { formatDate } from 'date-fns';
const validationSchema = Yup.object({
    type: Yup.string()
        .required("Action type is required")
        .notOneOf(["all"], "Please select a valid action"),
    updatedPhone: Yup.string().when("type", {
        is: "change_phone",
        then: (schema) =>
            schema
                .required("Phone number is required")
                .matches(/^[0-9]{10}$/, "Enter valid 10 digit number"),
    }),
    remark: Yup.string().max(200, "Remark cannot exceed 200 characters"),
});


const NDRDash = () => {
    const modalRef = useRef();
    const [open, setOpen] = useState(false)
    const [selectedPaymentType, setSelectedPaymentType] = useState('');
    const [toggleCleared, settoggleCleared] = useState(false);
    const [forceUpdate, setForceUpdate] = useState(0);
    const [openSideMenu, setOpenSideMenu] = useState(false);
    const [selectedRow, setselectedRow] = useState([]);
    const [selectedRowData, setselectedRowData] = useState([]);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [orderData, setOrderData] = useState([]);
    const [orderStatus, setorderStatus] = useState("Action Required");
    const [isOpen, setIsOpen] = useState(false);
    const [activeTab, setActiveTab] = useState("Action Required");
    // console.log('✌️activeTab --->', activeTab);
    const [showFilters, setShowFilters] = useState(true);
    const [expandedRows, setExpandedRows] = useState({});
    const closeModal = () => setOpenSideMenu(false);
    const toggleRow = (orderId) => {
        setExpandedRows((prev) => ({
            ...prev,
            [orderId]: !prev[orderId],
        }));
    };
    const handleShowHistory = (row) => {
        setselectedRowData(row); // Store the selected row data
        setOpen(true); // Open the history modal
    };

    const [createNDRAction, { loading: loaderCreateNdr }] = useMutation(CREATE_NDR);
    const [finalRange, setFinalRange] = useState({
        filterType: "Last 30 Days",
        startDate: new Date(),
        endDate: new Date(),
    });
    const [filter, setFilter] = useState('');
    const [filterOrder, setFilterOrder] = useState('');
    const [awbNumber, setawbNumber] = useState('');
    const [fetchAllOrders] = useLazyQuery(GET_NDR_LIST, {
        fetchPolicy: "cache-and-network"
    });
    const { filterType, startDate, endDate } = finalRange;
    const [searchUser, setSearchUser] = useState('');
    // const [isOpen, setIsOpen] = useState(false);
    const { data: GetOrderOrder, loading, refetch } = useQuery(GET_NDR_LIST, {
        variables: {
            page: page,
            limit,
            "sort": { key: "createdAt", type: -1 },
            paymentType: selectedPaymentType,
            "filter": filter?.trim(),
            from: finalRange?.startDate,
            to: finalRange?.endDate,
            status: orderStatus,
        },
        fetchPolicy: "cache-and-network",
    });

    const { data: NDRDataCount, refetch: refetchNDRCount } = useQuery(GET_NDR_COUNT, {
        variables: {
            paymentType: selectedPaymentType,
            "filter": filter?.trim(),
            from: finalRange?.startDate, // Use updated startDate
            to: finalRange?.endDate,
            status: activeTab !== "All" ? activeTab : null,
        },
        fetchPolicy: "cache-and-network",
    });
    // console.log('✌️NDRDataCount --->', NDRDataCount);
    const handlePagination = (page) => {
        // setLoader(true);
        setPage(page?.selected);
    };
    const handleSearch = (e, awb) => {
        if (awb === 'orderId') {
            setFilterOrder(e.target.value);
            setFilter(e.target.value)
        } else if (awb === 'awbNumber') {
            setFilter(e.target.value);
            setawbNumber(e.target.value)
        } else {
            setFilter(e.target.value);
        }
        setPage(1);
        handleClear();
    }
    // console.log('✌️GetOrderOrder --->', GetOrderOrder);
    useEffect(() => {
        if (GetOrderOrder?.getNDRList?.data) {
            setOrderData(GetOrderOrder?.getNDRList?.data);
        }
    }, [GetOrderOrder]);
    useEffect(() => {
        setForceUpdate(prev => prev + 1);
    }, [activeTab]);
    const handleTabClick = (tab) => {
        setActiveTab(tab);
        if (tab === 'Action Required') {
            setorderStatus('Action Required');
        } else if (tab === 'Action Requested') {
            setorderStatus('Action Requested');
        } else if (tab === 'RTO') {
            setorderStatus('RTO');
        } else if (tab === 'Delivered') {
            setorderStatus('Delivered');
        }
        handleClear();
    };
    const handleClear = () => {
        settoggleCleared(!toggleCleared)
        setselectedRow([]);
    }
    const onSelectedRowsChange = (data) => {
        // console.log('✌️data --->', data);
        if (data?.selectedCount > 0) {
            const awb = data?.selectedRows?.map((d) => d?.awb_number)
            // console.log('awb --->', awb);
            setselectedRow(awb);
        } else {
            handleClear();
        }
    }
    const renderActionCell = useCallback(
        (row) => {
            // console.log('✌️activeTab inside useCallback:', activeTab); // Should always log updated value

            if (activeTab === "Action Required") {
                return (
                    <button
                        onClick={() => {
                            setselectedRow([row?.awb_number]);
                            setOpenSideMenu(true);
                        }}
                        className="flex items-center gap-2 px-3 text-xs py-1 text-[#5C74FB] border border-[#5C74FB] rounded-md shadow-sm hover:shadow-md hover:bg-[#5C74FB] hover:text-white transition duration-200"
                    >
                        Action
                    </button>
                );
            } if (activeTab === "RTO") {
                return (
                    <span>-</span>
                )
            } else if (["RTO", "Action Requested", "Delivered"].includes(activeTab)) {
                if (!row?.ndr_history || row?.ndr_history?.length === 0) {
                    return "No History";
                }

                const sortedNDRHistory = [...row.ndr_history].sort(
                    (a, b) => new Date(b?.event_date) - new Date(a?.event_date)
                );

                const latestNDR = sortedNDRHistory[0];


                return (
                    <div className="tooltip-container text-xs">
                        {latestNDR?.courier_remarks?.split(" ").map((word, index) => {
                            const cleanedWord = word.replace(/_/g, " ");
                            const keywords = ["re-attempt", "change address", "change phone"];

                            return keywords.includes(cleanedWord.toLowerCase()) ? (
                                <span key={index} style={{ color: "green", textTransform: "uppercase" }}>
                                    {cleanedWord.toUpperCase()}{" "}
                                </span>
                            ) : (
                                <span key={index}>{cleanedWord} </span>
                            );
                        })}
                        <br />
                    </div>
                );
            }
        },
        [activeTab] // ✅ This ensures `activeTab` updates correctly
    );


    const NDRTableColumns = useMemo(() => {
        return [
            {
                name: "NDR DATE",
                sortable: true,
                selector: (row) => (
                    <span className="text-xs">
                        {row.ndr_history.length > 0
                            ? moment([...row.ndr_history].sort((a, b) => new Date(a?.event_date) - new Date(b?.event_date))[0]?.event_date).format("DD/MM/YYYY")
                            : moment().format("DD/MM/YYYY")}
                    </span>
                ),
            },
            {
                name: "ORDER ID",
                sortable: true,
                selector: (row) => row?.order_number,
                cell: (row) => (
                    <span
                        style={{ color: "#5C74FB", fontWeight: "500", cursor: "pointer" }}
                        className="text-xs"
                    >
                        {row?.order_number}
                    </span>
                ),
                width: "160px",
            },
            {
                name: "AWB NO",
                sortable: true,
                selector: (row) => row?.awb_number,
                cell: (row) => (
                    <span
                        style={{ color: "#5C74FB", fontWeight: "500", cursor: "pointer" }}
                        className="text-xs"
                        onClick={() =>
                            window.open(`/trackcourier?awb=${row?.awb_number}`, "_blank")
                        }
                    >
                        {row?.awb_number}
                    </span>
                ),
                width: "150px",
            },


            // {
            //     name: "PRODUCT",
            //     sortable: true,
            //     selector: (row) => row?.product,
            //     cell: (row) => (
            //         <span className="text-xs">Health & Beauty</span>
            //     ),
            //     width: "160px",
            // },
            {
                name: "CUSTOMER (Receiver)",
                sortable: true,
                selector: (row) =>
                    `${row?.deliveryAddress?.name || "----"} - ${row?.deliveryAddress?.address1 || "----"
                    }`,
                cell: (row) => (
                    <div
                        className="truncate max-w-xs cursor-pointer text-xs"
                        title={`${row?.deliveryAddress?.name || "----"} - ${row?.deliveryAddress?.address1 || "----"
                            }, ${row?.deliveryAddress?.city || "-"} ${row?.deliveryAddress?.zipCode || "-"
                            } - Mo: ${row?.deliveryAddress?.phone || "-"}`}
                    >
                        {row?.deliveryAddress?.name || "----"}
                    </div>
                ),
                width: "180px",
            },
            {
                name: "PAYMENT",
                sortable: true,
                selector: (row) => row?.payment_type,
                cell: (row) => (
                    <span className="text-xs font-semibold">
                        <span className="uppercase">({row?.payment_type})</span>
                    </span>
                ),
                width: "130px",
            },

            {
                name: "STATUS",
                sortable: true,
                selector: (row) => row?.status,
                cell: (row) => (
                    <span className="text-xs font-semibold text-green-600">
                        {row?.status || "-"}
                    </span>
                ),
                width: "120px",
            },

            {
                name: "Village?",
                sortable: true,
                selector: (row) =>
                    row?.isDeliverToVillage ? "YES" : "NO",
                cell: (row) => (
                    <div
                        className="truncate max-w-xs cursor-pointer text-xs"
                        title={`Village Delivery? ${row?.VillageName || ""}`}
                    >
                        {row?.isDeliverToVillage ? "YES" : "NO"}{" "}
                        <span className="ml-3 font-semibold text-green-600">
                            {row?.extraChargeOfVillage || 0}
                        </span>
                    </div>
                ),
            },
            {
                name: "WEIGHT",
                sortable: true,
                selector: (row) => row?.package_weight,
                cell: (row) => (
                    <span className="text-xs">{row?.package_weight || 0}(KG)</span>
                ),
                width: "130px",
            },
            {
                name: "EXCEPTION INFO",
                sortable: true,
                width: "200px",
                selector: (row) => {
                    if (!row?.ndr_history || row?.ndr_history?.length === 0) return "No History";

                    // Sort ndr_history by event_date in descending order (latest first)
                    const sortedNDRHistory = [...row?.ndr_history].sort(
                        (a, b) => new Date(b?.event_date) - new Date(a?.event_date)
                    );

                    // Get the latest entry
                    const latestNDR = sortedNDRHistory[0];
                    const latestCourierAttempt = sortedNDRHistory?.find(entry => entry.By === "courier");

                    return `${latestNDR?.total_attempts || latestCourierAttempt?.total_attempts} Attempt(s) - ${latestNDR?.courier_remarks || "No Remarks"}`;
                },
                cell: (row) => {
                    if (!row?.ndr_history || row?.ndr_history?.length === 0) {
                        return <div className="truncate max-w-xs text-xs">No History</div>;
                    }

                    // Sort ndr_history by event_date in descending order (latest first)
                    const sortedNDRHistory = [...row?.ndr_history].sort(
                        (a, b) => new Date(b?.event_date) - new Date(a?.event_date)
                    );

                    // Get the latest entry
                    const latestNDR = sortedNDRHistory[0];
                    const latestCourierAttempt = sortedNDRHistory?.find(entry => entry.By === "courier");

                    return (
                        <div
                            className="truncate max-w-xs cursor-pointer text-xs"
                            title={`Attempts: ${latestNDR?.total_attempts || latestCourierAttempt?.total_attempts}
       Courier Remarks: ${latestNDR?.courier_remarks || "No Remarks"}`}
                        >
                            <div className="flex flex-col space-y-1">
                                <span className="text-xs text-green-600">
                                    {latestNDR?.total_attempts || latestCourierAttempt?.total_attempts} Attempt(s)
                                </span>
                                <span className="text-xs text-gray-700">
                                    {latestNDR?.courier_remarks || "No Remarks"}
                                </span>
                                <p className="text-blue-600 cursor-pointer" onClick={() => handleShowHistory(row)}>
                                    Show History
                                </p>

                            </div>
                        </div>

                    );
                },
            },
            {
                name: "ACTION",
                cell: renderActionCell,
                width: "150px",
            },
        ];
    }, [renderActionCell]);
    const handleDateChange = useCallback((range) => {
        setFinalRange(range);
    }, []);

    const resetData = () => {
        setPage(1);
        setFilter("");
        setSearchUser("");
        setawbNumber("");
        setFilterOrder("");
        setorderStatus('Action Required');
        setSelectedPaymentType('');
        setActiveTab('Action Required');
        handleClear();

        const defaultRange = getDateRange("Last 30 Days");
        setFinalRange({
            filterType: "Last 30 Days",
            startDate: defaultRange?.startDate,
            endDate: defaultRange?.endDate,
        });

        handleDateChange({
            filterType: "Last 30 Days",
            startDate: defaultRange?.startDate,
            endDate: defaultRange?.endDate,
        });
    }
    const transformDataForExport = (data) => {
        // console.log('✌️data --->', data);
        return data?.map((shipment, index) => {
            // console.log('✌️shipment --->', shipment);
            const fullAddress = shipment?.deliveryAddress?.address1 || '';
            const city = shipment?.deliveryAddress?.city || '';
            const state = shipment?.deliveryAddress?.stateId?.name || '';
            const zipCode = shipment?.deliveryAddress?.zipCode || '';
            const sortedNDRHistory = [...shipment?.ndr_history].sort(
                (a, b) => new Date(a?.event_date) - new Date(b?.event_date)
            );
            // console.log('✌️sortedNDRHistory --->', sortedNDRHistory);
            const date = sortedNDRHistory.length > 0
                ? moment(sortedNDRHistory[0]?.event_date).format("DD/MM/YYYY")
                : "N/A";



            // Get the latest entry
            const latestNDR = sortedNDRHistory[0];
            const latestCourierAttempt = sortedNDRHistory?.find(entry => entry?.By === "courier");


            return {
                "ID": shipment?.order_id,
                "NDR Date": date,
                "Pickup Date": moment(shipment?.createdAt).format("DD/MM/YYYY"),
                "Order Number": shipment?.order_number,
                "Product Name": shipment?.ProductName,
                "Payment Type": shipment?.payment_type,
                "Order Amount": shipment?.ProductPrice,
                "AWB Number": shipment?.awb_number,
                "Order Status": shipment?.status,
                "Customer Name": shipment?.deliveryAddress?.name,
                "Customer Phone": shipment?.deliveryAddress?.phone,
                "Shipping Address": fullAddress,
                "City": city,
                "State": state,
                "Pincode": zipCode,
                "Last Action By": latestNDR?.By,
                "Attempts": latestCourierAttempt.total_attempts,
                "Details": latestNDR?.courier_remarks,
            };
        });
    };

    const downloadExcel = async () => {
        const { data } = await fetchAllOrders({
            variables: {
                page: page,
                limit: 100000,
                "sort": { key: "createdAt", type: -1 },
                paymentType: selectedPaymentType,
                "filter": filter?.trim(),
                from: finalRange?.startDate, // Use updated startDate
                to: finalRange?.endDate,
                status: orderStatus,
            },
            fetchPolicy: "cache-and-network"
        });
        // console.log('✌️data --->', data);

        if (!data?.getNDRList?.count) {
            toast.error("No data available for export")
            return;
        }

        // Transform data for export
        const transformedData = transformDataForExport(data?.getNDRList?.data);

        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(transformedData);

        // Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Exception");

        // Generate and download the Excel file
        XLSX.writeFile(workbook, "Exception.xlsx");
    };

    return (
        <>

            {/* Header */}
            <Header />

            <div className="flex min-h-screen bg-slate-100 overflow-hidden ml-16">
                {/* Sidebar */}

                <SideBar />

                {/* Main Content */}
                <div className="flex-1 space-y-3 px-0 py-0 md:p-6 overflow-x-hidden ">
                    <h1 className="text-xl font-bold px-4 md:px-0 mb-3">Non-Delivery Report</h1>
                    <div className="bg-slate-100">
                        <div className="p-6 bg-white border rounded-lg space-y-6">
                            {/* Header Section */}
                            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center">
                                <div className="flex items-center md:space-x-3">
                                    <BsBox className="text-2xl hidden md:block text-gray-900 " />
                                    <h1 className="text-lg font-bold text-gray-800">
                                        Domestic Shipment Services Across India
                                    </h1>
                                </div>
                                <div className="flex items-center mt-4 lg:mt-0 space-x-6">

                                    <div className="flex space-x-3">
                                        <button onClick={downloadExcel} className="flex items-center gap-2 text-sm  px-4 py-1 bg-slate-700 text-white rounded-lg hover:bg-slate-800">
                                            <FiDownload className="text-lg" />
                                            Export
                                        </button>
                                        <button
                                            onClick={() => setShowFilters(!showFilters)}
                                            className="flex items-center gap-2 text-sm px-4 py-1 bg-slate-700 text-white rounded-lg hover:bg-slate-800"
                                        >  {showFilters ? <FiX className="text-lg" /> : <FiFilter className="text-lg" />}
                                            {showFilters ? "Close" : "Filter"}
                                        </button>

                                    </div>
                                </div>
                            </div>

                            {/* Filter Section */}
                            {showFilters && (
                                <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
                                    {/* Search Filter */}
                                    <div className="space-y-2">
                                        <label className="block text-sm font-medium text-gray-700">Custom Search</label>
                                        <input
                                            type="text"
                                            value={searchUser}
                                            onChange={(e) => { setSearchUser(e.target.value); handleSearch(e) }}
                                            // onKeyDown={handleSearch}
                                            placeholder="Search..."
                                            className="w-full border border-gray-300 rounded-md  px-3 py-1.5 text-gray-700 focus:ring-1 focus:ring-slate-900 focus:outline-none"
                                        />
                                    </div>


                                    {/* Order IDs */}
                                    {/* <div className="space-y-2">
                                        <label className="block text-sm font-medium text-gray-700">
                                            Customer
                                        </label>
                                        <input
                                            type="text"
                                            value={filterOrder}
                                            onChange={(e) => { handleSearch(e, 'orderId') }}                                        // onKeyDown={() => handleSearch('orderId')}
                                            placeholder="Customer Name"
                                            className="w-full border border-gray-300 rounded-md  px-3 py-1.5 text-gray-700 focus:ring-1 focus:ring-slate-900 focus:outline-none"
                                        />
                                    </div> */}

                                    {/* AWB Numbers */}
                                    <div className="space-y-2">
                                        <label className="block text-sm font-medium text-gray-700">
                                            AWB No.
                                        </label>
                                        <input
                                            type="text"
                                            value={awbNumber}
                                            onChange={(e) => { setawbNumber(e.target.value); handleSearch(e, 'awbNumber') }}
                                            placeholder="AWB Nos (comma-separated)"
                                            className="w-full border border-gray-300 rounded-md  px-3 py-1.5 text-gray-700 focus:ring-1 focus:ring-slate-900 focus:outline-none"
                                        />
                                    </div>

                                    {/* Type Filter */}
                                    <div className="space-y-2">
                                        <label className="block text-sm font-medium text-gray-700">Payment Type</label>
                                        <Select
                                            options={typeOptions}
                                            defaultValue={typeOptions[0]}
                                            className="w-full"
                                            value={typeOptions.find(option => option?.value === selectedPaymentType) || null}
                                            onChange={(selectedOption) => setSelectedPaymentType(selectedOption?.value)}
                                            classNamePrefix="react-select"
                                            styles={{
                                                control: (base, state) => ({
                                                    ...base,
                                                    borderColor: state.isFocused ? '#d1d5db' : '#d1d5db',
                                                    '&:hover': { borderColor: '#64748B' },
                                                    boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                                    borderRadius: '0.375rem',
                                                }),
                                                singleValue: (base) => ({
                                                    ...base,
                                                    color: '#000000',
                                                    fontSize: '0.875rem',
                                                }),
                                                option: (base, state) => ({
                                                    ...base,
                                                    backgroundColor: state.isSelected ? '#cbd5e1' : state.isFocused ? '#cbd5e1' : 'white',
                                                    color: state.isSelected ? '#000000' : '#000000',
                                                    fontSize: '0.875rem',
                                                    '&:hover': {
                                                        backgroundColor: '#cbd5e1',
                                                        color: '#000000',
                                                        fontSize: '0.875rem',
                                                    }
                                                }),
                                                placeholder: (base) => ({
                                                    ...base,
                                                    fontSize: '14px',
                                                    color: '#A3AAB5',
                                                    fontSize: '0.875rem',
                                                }),
                                            }}
                                        />
                                    </div>


                                    <div className="space-y-2">
                                        <label className="block text-sm font-medium text-gray-700">From Date:</label>
                                        <DateFilter onDateChange={handleDateChange} defaultFilterType={finalRange?.filterType} />
                                    </div>
                                    <div className="flex items-end h-full" onClick={resetData}>
                                        <p className="font-medium mb-1 cursor-pointer bg-slate-300 text-black px-4 py-1.5 rounded-lg text-sm hover:bg-slate-400">
                                            Reset Filters
                                        </p>
                                    </div>
                                </div>
                            )}
                            {/* Tab Section */}
                            <div className="flex flex-wrap mb-4 mt-10 gap-3">
                                {[
                                    { label: "Action Required", count: NDRDataCount?.getNDRListFranchiseCount?.actionRequiredCount || 0 },
                                    { label: "Action Requested", count: NDRDataCount?.getNDRListFranchiseCount?.actionRequestedCount || 0 },
                                    { label: "Delivered", count: NDRDataCount?.getNDRListFranchiseCount?.deliveredCount || 0 },
                                    { label: "RTO", count: NDRDataCount?.getNDRListFranchiseCount?.rtoCount || 0 },
                                ].map((tab) => (
                                    <button
                                        key={tab.label}
                                        onClick={() => handleTabClick(tab?.label)}
                                        className={`px-5 py-1.5 rounded-md shadow-sm border transition-all font-medium text-sm
            ${activeTab === tab.label
                                                ? 'bg-slate-700 text-white border-slate-700'
                                                : 'bg-white text-gray-800 border-gray-200'
                                            }
          `}
                                    >
                                        {tab?.label} ({tab?.count})
                                    </button>
                                ))}
                            </div>


                        </div>

                        {activeTab === "Action Required" && <div className="flex mt-3 flex-wrap items-center bg-white gap-2 p-2 border rounded-lg w-full">
                            {/* Selected Count */}
                            <div className="px-4 rounded-lg hover:bg-slate-200 transition text-gray-900 font-semibold text-sm flex items-center">
                                <span className="text-lg">{selectedRow?.length || 0}</span>
                                <span className="ml-1 text-gray-600 text-sm">selected</span>
                            </div>

                            {/* Bulk NDR Button */}
                            <button
                                className={`px-4 py-1 ${selectedRow?.length === 0 ? "bg-slate-400 cursor-not-allowed" : "bg-gray-900 hover:bg-gray-800 transition-all duration-300"}  text-white text-sm font-semibold rounded-lg `}
                                onClick={() => setOpenSideMenu(true)} // Function to handle Bulk NDR action
                                disabled={selectedRow?.length === 0} // Disable if no items selected

                            >
                                Bulk NDR
                            </button>
                        </div>}
                    </div>

                    <div className="mt-2 bg-white p-4 border rounded-lg">
                        <Table
                            key={forceUpdate}
                            columns={NDRTableColumns}
                            data={GetOrderOrder?.getNDRListFranchiseData?.data || []}
                            currentPage={page}
                            limit={limit}
                            setLimit={setLimit}
                            setPage={setPage}
                            totalRecords={GetOrderOrder?.getNDRListFranchiseData?.count || 0}
                            handlePagination={handlePagination}
                            loading={loading}
                            multiSelectRow={onSelectedRowsChange}
                            clearSelectedRows={toggleCleared}
                        />

                    </div>
                </div>
            </div>



            {openSideMenu && (
                <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex justify-end">
                    <div
                        ref={modalRef}
                        className="w-full sm:w-[400px] bg-white shadow-lg transform transition-transform h-full overflow-y-auto duration-300 translate-x-0"
                    >
                        {/* Modal Header */}
                        <div className="flex justify-between items-center p-4 border-b">
                            <h2 className="font-semibold">NDR Submit Form</h2>
                            <button onClick={closeModal} className="text-2xl font-bold">
                                <IoClose />
                            </button>
                        </div>

                        <Formik
                            initialValues={{ type: "all", updatedPhone: "", remark: "" }}
                            validationSchema={validationSchema}
                            onSubmit={async (values, { resetForm }) => {
                                try {
                                    if (!selectedRow || selectedRow?.length === 0) {
                                        toast.error("No AWB selected!");
                                        return;
                                    }
                                    const requestBody = selectedRow?.map((awb) => ({
                                        awb_number: awb, // Process each AWB dynamically
                                        user_action: values?.type,
                                        courier_remarks: values?.remark,
                                        action_data:

                                            //  values.action === "change_address"
                                            //     ? {
                                            //         name: values?.name || "", // Assuming you have a name field
                                            //         address_1: values?.address_1 || "",
                                            //         address_2: values?.address_2 || ""
                                            //     }
                                            //     : 
                                            values.type === "change_phone"
                                                ? { phone: values?.updatedPhone || "" }
                                                : values.type,
                                    }));
                                    // console.log('✌️requestBody --->', requestBody);
                                    const { data } = await createNDRAction({ variables: { input: requestBody } });
                                    // console.log('✌️data --->', data);
                                    if (data?.createNDRActionData) {
                                        refetch();
                                        refetchNDRCount();
                                        closeModal();
                                        setselectedRow([])
                                        resetForm()
                                        toast.success("NDR Submitted Successfully");
                                    } else {
                                        toast.error("Failed to submit action.");
                                        setselectedRow([])
                                    }
                                } catch (error) {
                                    toast.error(error.message || "Something went wrong!");
                                }
                            }}
                        >
                            {({ values, touched, errors }) => (
                                <Form>
                                    {/* Modal Content */}
                                    <div className="p-4 space-y-6">
                                        {/* Type */}
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Action Type <span className="text-red-600">*</span>
                                            </label>
                                            <Field
                                                as="select"
                                                name="type"
                                                className={`w-full h-10 px-3 bg-blue-50 rounded-md text-sm focus:outline-none border ${errors.type && touched.type
                                                    ? "border-red-500"
                                                    : "border-gray-300"
                                                    }`}
                                            >
                                                <option value="all">Choose Action</option>
                                                <option value="return">RTO (Return)</option>
                                                <option value="re-attempt">Re-Attempt (Re-Delivery)</option>
                                                <option value="hold for 48hrs">Hold For 48Hrs</option>
                                                <option value="change_phone">Update Phone Number</option>
                                            </Field>
                                            <ErrorMessage
                                                name="type"
                                                component="div"
                                                className="text-red-500 text-xs mt-1"
                                            />
                                        </div>

                                        {/* Conditional Input Field */}
                                        {values.type === "change_phone" && (
                                            <div className="mt-3">
                                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                                    Enter Updated Contact Number <span className="text-red-600">*</span>
                                                </label>
                                                <Field
                                                    type="text"
                                                    name="updatedPhone"
                                                    placeholder="Enter new phone number"
                                                    className={`w-full h-10 px-3 bg-blue-50 rounded-md text-sm focus:outline-none border ${errors.updatedPhone && touched.updatedPhone
                                                        ? "border-red-500"
                                                        : "border-gray-300"
                                                        }`}
                                                />
                                                <ErrorMessage
                                                    name="updatedPhone"
                                                    component="div"
                                                    className="text-red-500 text-xs mt-1"
                                                />
                                            </div>
                                        )}

                                        {/* Remark Field */}
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Remark (Optional)
                                            </label>
                                            <Field
                                                as="textarea"
                                                name="remark"
                                                placeholder="Enter remark"
                                                rows="3"
                                                className={`w-full px-3 py-2 rounded-md text-sm focus:outline-none border ${errors.remark && touched.remark
                                                    ? "border-red-500"
                                                    : "border-gray-300"
                                                    }`}
                                            />
                                            <ErrorMessage
                                                name="remark"
                                                component="div"
                                                className="text-red-500 text-xs mt-1"
                                            />
                                        </div>
                                    </div>

                                    {/* Buttons */}
                                    <div className="flex flex-col sm:flex-row gap-2 p-4">
                                        <button
                                            type="button"
                                            onClick={closeModal} // 👈 Cancel function
                                            className="w-full sm:w-1/2 px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-100 text-sm"
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="w-full sm:w-1/2 px-4 py-2 bg-slate-700 text-white rounded-md hover:bg-slate-800 text-sm"
                                        >
                                            Submit
                                        </button>
                                    </div>

                                </Form>
                            )}
                        </Formik>
                    </div>
                </div >
            )}
            <NDRTableHistory open={open} setOpen={setOpen} selectedRowData={selectedRowData?.ndr_history} />
        </>
    )
}

export default NDRDash
